import CourseslistContent from '../section/courseslistpage/CourseslistContent'

export default function CoursesListPage() {
  return (
    <div className="h-full">
      <CourseslistContent/>
    </div>
  )
}